export default __webpack_public_path__ + "static/media/18.42be7342.png";